import { Tag, Text } from '@interco/inter-toranja'
import {
  TextSize,
  TextType,
  TextWeight,
} from '@interco/inter-toranja/dist/components/Atoms/Text/types'
import { SIZE, TAGGING_EVENT } from '@interco/inter-toranja/dist/utils/pattern'

import type { ListItemProps } from './interfaces'
import * as S from './styles'

export const ListItem = ({
  label,
  paragraph,
  tags,
  state = 'enabled',
  showDivider = false,
  variant = 'contained',
  onTag,
  onClick,
  trailingText,
}: ListItemProps) => {
  const handleContainerClick = () => {
    if (!onClick || state !== 'enabled') {
      return
    }

    onTag?.((x) => ({
      ...x,
      name: TAGGING_EVENT.INTERACTION_CLICK,
      ComponentProperties: {
        component_name: 'ListItem',
        label,
        variant,
        size: SIZE.MEDIUM,
        hierarchy: '',
        state,
        show_leading_icon: false,
        leading_icon: '',
        leading_variant: '',
        paragraph: paragraph ?? '',
        paragraph_support: trailingText?.paragraph ?? '',
        tag_label: tags?.[0]?.label ?? '',
        tag_trailing_label: false,
        trailing_variant: '',
      },
    }))

    onClick()
  }

  return (
    <>
      <S.Container
        variant={variant}
        state={state}
        onClick={handleContainerClick}
        role={onClick ? 'button' : undefined}
        tabIndex={onClick && state === 'enabled' ? 0 : undefined}
      >
        <S.ContentWrapper>
          <S.MainContent>
            <S.BodyContent>
              <Text
                textType={TextType.Body}
                textSize={TextSize.Medium}
                textWeight={TextWeight.Bold}
                as="span"
              >
                {label}
              </Text>
              {paragraph && (
                <Text
                  textType={TextType.Body}
                  textSize={TextSize.Medium}
                  textWeight={TextWeight.Regular}
                  colorVariant="secondary"
                  as="span"
                >
                  {paragraph}
                </Text>
              )}
              {tags && tags.length > 0 && (
                <S.TagsContainer>
                  {tags.map((tag) => (
                    <Tag
                      key={tag.label}
                      label={tag.label}
                      size="small"
                      hierarchy="soft"
                      color={tag.color}
                    />
                  ))}
                </S.TagsContainer>
              )}
            </S.BodyContent>
            {trailingText && (
              <S.TrailingContent>
                <Text
                  textType={TextType.Body}
                  textSize={TextSize.Medium}
                  textWeight={TextWeight.Bold}
                  as="span"
                >
                  {trailingText.label}
                </Text>
                {trailingText.paragraph && (
                  <Text
                    textType={TextType.Body}
                    textSize={TextSize.Medium}
                    textWeight={TextWeight.Regular}
                    colorVariant="secondary"
                    as="span"
                  >
                    {trailingText.paragraph}
                  </Text>
                )}
              </S.TrailingContent>
            )}
          </S.MainContent>
        </S.ContentWrapper>
      </S.Container>
      {showDivider && <S.Divider />}
    </>
  )
}
